module.exports = __webpack_public_path__ + "img/17.38430c1c.png";